export default {
	"862933ac7f360b6b2fd4b24213480431": "请选择可用优惠券",
	"ac52b8119d35b04fdd6793a65b929fcc": "无可用优惠",
	"8f51667edd111b7a03b1108733d4a340": "无可用代金券",
	"3fd254568652167791795ad640c7a28a": "请选择可用代金券",
	"a893fa4579f7a97990a3c599dded4e92": "商品价格",
	"1d59b98806a14ed49870ebe5d49ea5a7": "优惠金额",
	"db261923bd8f684a1e5aabf371e19c5e": "优惠券",
	"2214d3c5f836c44fbae49da0e0f5dbbf": "代金券",
	"e05bcef28c7bbeb6454df0dd89544a19": "已优惠",
	"8a50c5528c9de6ca7c9d381f766cea6b": "合计"
}
